import { IDocumentEntity } from '../../entitites/common/document.entity';

export class DocumentDto {
  readonly guid: string;
  readonly filename: string;
  readonly mimetype: string;

  constructor(document: IDocumentEntity) {
    this.guid = document.guid;
    this.filename = document.filename;
    this.mimetype = document.mimetype;
  }
}
